<template>
  <div id="app">
    <router-view v-if="siteInfo"/>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
export default {
  name: 'App',
  computed: {
    ...mapState({
      siteInfo: state => state.home.siteInfo
    })
  },
  methods: {
    ...mapActions(['setSiteInfo']),
    loadSiteInfo () {
      this.$ajax({
        url: '/auth/index/home/loadSiteInfo',
        method: 'post'
      }).then(response => {
        let siteInfo = response.data['siteInfo'] || {}
        let siteTitle = siteInfo.siteTitle || '学习平台'
        document.title = siteTitle
        this.setSiteInfo(siteInfo)
      }, (e) => {
        this.setSiteInfo({})
      })
    }
  },
  mounted () {
    this.loadSiteInfo()
  }
}
</script>
<style lang="scss">
  @use "styles/index" as *;
  #app {
    height: 100%;
  }
</style>
